var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mw-dialog',{ref:"dialog",attrs:{"title":_vm.$lang('附件管理'),"appendToBody":false,"size":"large_mini"}},[_c('mw-ntko-attachment',{attrs:{"defButtons":_vm.buttons,"propObject":_vm.propObject},on:{"dataLoaded":_vm.tableDataLoaded}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a82a5d5a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/components/public-dialog/ntko/ntko-attachment.vue
// module id = 1169
// module chunks = 0 1